export const EGI_APP_ID_ROUTE_PARAM = 'egiApp';
export const EGI_APP_ROOT = 'egiAppRoot';

export const NO_ROOT_ERROR_MESSAGE = `No route is tagged as root! Make sure to mark one like this:
        {
          path: '',
          data: {
            [EGI_APP_ROOT]: true
          }
        }
      `;
